import { render } from "./PlayHistoryModal.vue?vue&type=template&id=24594124&scoped=true"
import script from "./PlayHistoryModal.vue?vue&type=script&lang=js"
export * from "./PlayHistoryModal.vue?vue&type=script&lang=js"

import "./PlayHistoryModal.vue?vue&type=style&index=0&id=24594124&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24594124"]])

export default __exports__